import React, { useState, useEffect } from "react";
import styles from "./Purpose.module.css";
import { Row, Col, Spinner, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { purposefetchData } from "../../api";
import NewHeader from "../NavBar/newHeader";
import Footer from "../../component/Footer/Footer";
import { useMyContext } from "../../myContext";
import RectangularCard from "../../common/RectangularCard/RectangularCard";
import education from "../../public/assets/education.svg";
import travel from "../../public/assets/Featured icon.svg";
import rightArrow from "../../public/assets/rightArrow.svg";
import HeadWithSubHead from "../../common/HeadWithSubHead";
import Stepper from "../../component/Stepper/Stepper";

const Purpose = () => {
  const [subPurposeOptions, setSubPurposeOptions] = useState([]);
  const [selectedfundObject, setSelectedfundObject] = useState({});
  const [loading, setLoading] = useState(true);
  const { purpose, purposeId, setPurposeId, acceptTandCofPurpose, setAcceptTandCofPurpose, themeColor, loadingLogo } = useMyContext();
  const navigate = useNavigate();
  const history = useNavigate();
  const selectedPurpose = purpose !== "" ? purpose : sessionStorage.getItem('purpose')

  const subPurposeOrderKeywords = [
    "hostel",
    "university",
    "rent",
    "gic",
    "blocked"
  ];

  const sortSubPurposes = (subPurposes) => {
    if (!subPurposes) return [];
    return [...subPurposes].sort((a, b) => {
      const titleA = a.title?.toLowerCase() || "";
      const titleB = b.title?.toLowerCase() || "";
      const indexA = subPurposeOrderKeywords.findIndex(keyword => titleA.includes(keyword));
      const indexB = subPurposeOrderKeywords.findIndex(keyword => titleB.includes(keyword));
      // Items not in the order list go to the end
      const orderA = indexA === -1 ? subPurposeOrderKeywords.length : indexA;
      const orderB = indexB === -1 ? subPurposeOrderKeywords.length : indexB;
      return orderA - orderB;
    });
  };

  const fetchData = async () => {
    try {
      purposefetchData().then((response) => {
        if(response && response.data){
        setLoading(false);
        setSelectedfundObject(findObjectByTitle(response.data, selectedPurpose ));
        }
      });
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedfundObject && selectedfundObject.subPurpose) {
      const sortedSubPurposes = sortSubPurposes(selectedfundObject.subPurpose);
      setSubPurposeOptions(sortedSubPurposes);

      // Set first item (Hostel/Living Expenses) as default selection
      const defaultOption = sortedSubPurposes[0];
      if (defaultOption && purposeId === "") {
        setPurposeId(defaultOption.purposeId);
        sessionStorage.setItem("subPurpose", defaultOption.title);
      }
    }
  }, [selectedfundObject]);

  useEffect(() => {
    const sessionPurpose = sessionStorage.getItem('purpose');
    if(sessionPurpose === ""){
      history('/transaction-detail')
    }else{
      sessionStorage.setItem("nextStep", "START_TRANSFER");
      fetchData();
    }
   
  }, []);


  const findObjectByTitle = (dataArray, titleToFind) => {
    return dataArray.find((item) => item.title === titleToFind);
  };

  const proceedToKyc = () => {
    sessionStorage.setItem("nextStep", "KYC_SELECTION");
    sessionStorage.setItem("purposeId", purposeId);
    navigate("/onboard");
  };

  return (
    <>
      <NewHeader show={true} />
      <Stepper stepPercent={0} />
      {loading ? (
        <Spinner animation="border" className={styles.spinnerColorOutside} style={{borderColor: themeColor, borderRightColor: "#eaecf0"}} />
      ) : (
        <>
          <div className={`container ${styles.mainContainer}`}>
            <HeadWithSubHead
              head="LRS Fund Transfer:"
              subHead="Purpose Selection"
            />
            <Row className={styles.containerbox}>
              <Col md={3} sm={3} xs={12}>
                <p md={12} className={styles.fundTransferHeading}>
                  Purpose of Fund Transfer
                </p>
              </Col>
              <Col md={7} sm={9} xs={12}>
                <RectangularCard
                  image={selectedPurpose === "Travel" ? travel : education}
                  heading={selectedPurpose}
                  subHeading="Send money abroad to pay for Rent, University Tuition, Blocked Account or GIC"
                />
              </Col>
            </Row>
            <Row className={styles.containerbox}>
              <Col md={3} sm={3} xs={12}>
                <p md={12} className={styles.fundTransferHeading}>
                  Reason
                </p>
                <p md={12} className={styles.subPurposeHeading}>
                Please pick the relevant reason for the remittance.
                </p>
              </Col>
              <Col md={7} sm={9} xs={12}>
                {subPurposeOptions &&
                  subPurposeOptions.map((item) => {
                    return (
                      <RectangularCard
                        image={education}
                        heading={item.title}
                        checkbox={true}
                        selectedObject={item}
                        description={item.description}
                      />
                    );
                  })}
              </Col>
            </Row>
            <Row className={styles.legalBox} style={{ border: "0px" }}>
              <div class="form-check" className={styles.checkMark}>
                <input
                  class="form-check-input"
                  className={styles.checkbox}
                  type="checkbox"
                  id="flexCheckDefault"
                  checked={acceptTandCofPurpose}
                  onChange={() => {
                    setAcceptTandCofPurpose(!acceptTandCofPurpose);
                  }}
                />
                <label
                  class="form-check-label"
                  className={styles.checklabel}
                  for="flexCheckDefault"
                >
                  You agree to our <a href="https://help.stockal.com/portal/en/kb/articles/terms-of-use-for-borderlesspe" target="_blank" rel="noopener noreferrer">Terms of Service</a> when you proceed.
                </label>
              </div>
            </Row>
            {loadingLogo ? <Row md={6} className={styles.ProceedButtton}>
              <Button
                className={styles.sendMoneyButton}
                onClick={() => proceedToKyc()}
                disabled={purposeId === "" || acceptTandCofPurpose === false}
                style={{backgroundColor: themeColor, border: "0px"}}
              >
                Proceed
                <img className={styles.rightArrow} src={rightArrow} alt="" />
              </Button>
            </Row> : ""}
          </div>
          <Footer />
        </>
      )}
    </>
  );
};

export default Purpose;
